import { useBrand } from "../components/BrandProvider";
var useDataQaId = function useDataQaId(props) {
  var _ref = useBrand() || {},
    testAttributeName = _ref.testAttributeName,
    autoApplyDataTestId = _ref.autoApplyDataTestId;
  var finalDataTestId = props.dataTestId;
  if (autoApplyDataTestId && !props.dataTestId && testAttributeName && props[testAttributeName]) {
    finalDataTestId = props[testAttributeName];
  }
  return finalDataTestId;
};
export default useDataQaId;